import { State } from '../../types';

const missingAddonSelection = fieldName => `Choose an option for ${fieldName}`;
const missingAddonPrice = fieldName => `Enter price for ${fieldName}`;

export const nextStepValidation = (state: State): string[] => {
  const errors: string[] = [];
  const {
    projectOptions,
    totalContractAmount,
    isFinancingIncluded,
    roofSize,
    shingleColor,
    distributionWarranty,
  } = state.order;

  if (!totalContractAmount) {
    errors.push('Total contract amount');
  }

  if (isFinancingIncluded === null) {
    errors.push('Indicate financing option');
  }

  if (!roofSize) {
    errors.push('Indicate roof size');
  }
  if (!distributionWarranty && state.isAccessProgram && state.isDistribution) {
    errors.push('Indicate Distribution Warranty');
  }

  if (!shingleColor && state.isAccessProgram && state.isDistribution) {
    errors.push('Choose a shingle color');
  }

  if (projectOptions?.rainGutters === undefined) {
    errors.push(missingAddonSelection('rain gutters'));
  }

  if (projectOptions?.rainGutters && !projectOptions?.rainGutters.price) {
    errors.push(missingAddonPrice('rain gutters'));
  }

  if (projectOptions?.gutters === undefined) {
    errors.push(missingAddonSelection('gutters'));
  }

  if (projectOptions?.gutters && !projectOptions?.gutters.price) {
    errors.push(missingAddonPrice('gutters'));
  }

  if (projectOptions?.decking === undefined) {
    errors.push(missingAddonSelection('decking'));
  }

  if (projectOptions?.decking && !projectOptions?.decking.price) {
    errors.push(missingAddonPrice('decking'));
  }

  if (projectOptions?.skylights === undefined) {
    errors.push(missingAddonSelection('skylight'));
  }

  if (projectOptions?.skylights && !projectOptions?.skylights.price) {
    errors.push(missingAddonPrice('skylight'));
  }

  return errors;
};
